<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
      
    </v-alert>
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :customTopActions="true"
      :bodyFilter="true"
      item-key="id"
      table-height="70vh"
    >
    <template v-slot:top>
        <v-toolbar flat>
          <v-chip
            v-if="selectedData.length > 0"
            close
            @click:close="clearSelected"
          >
            {{ `${selectedData.length} data(s) selected` }}
          </v-chip>

          <v-spacer />
          <template>
        
            <v-btn

              color="primary"
              class="mb-2 rounded-pill elevation-0"
              :style="{ 'margin-right': '10px' }"
              :disabled="loading"
              @click="openApproveModal"
              >Approve
            </v-btn>
            <v-btn
              color="error"
              class="mb-2 rounded-pill elevation-0"
              :style="{ 'margin-right': '10px' }"
              :disabled="loading"
              @click="openRejectModal"
              >Reject
            </v-btn>
            <v-btn
              color="warning"
              icon
              class="mb-2"
              :loading="loading"
              :disabled="loading"
              :style="{ 'margin-right': '10px' }"
              @click="getData"
              ><v-icon>mdi-refresh</v-icon></v-btn
            >
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link @click="exportItem()">
                  <v-list-item-icon>
                    <v-icon>mdi-file-excel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Export to excel</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-toolbar>
      </template>
    <template v-slot:body-prepend>
      <ForceActiveFilter
        :search="search"
        :dataList="allData"
        :selectedData="selectedData"
        :selectAllData="selectAllData"
        v-on:getDataParent="getData"
        v-on:selectedDataParent="changeSelectedData"
        v-on:selectAllDataParent="changeSelectAllData"
      />
    </template>
    <template v-slot:custom="{ item }">
      <v-checkbox
        class="ma-0"
        dense
        hide-details="true"
        v-model="selectedData"
        :value="item.id"
      />
    </template>
    </TableView>
    <v-dialog v-model="dialogApprove" width="500">
      <ConfirmDialog
        title="Will you continue the process ?"
        caution="Caution: this action cannot be undone !"
        v-on:confirmParent="
          dialogName === 'approve' ? confirm('approve') : confirm('reject')
        "
        v-on:closeCancelParent="() => (dialogApprove = false)"
      />
    </v-dialog>
  </v-card>
</template>

<script>

import approvalForceMixin from '../../components/merchant-application/approval-active/approvalForceMixin';

export default {
  mixins: [approvalForceMixin],
  components: {
    ForceActiveFilter: () =>
      import('../../components/table/ForceActiveFilter.vue'),
    ConfirmDialog: () => import('../../components/ConfirmDialog.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
